import { PropertyAPI } from "../../axios";

export const actions = {

    //Property Inventory
    GetPropertyInventory(context, data) {
        return PropertyAPI.get(`Inventory/Campus/${data}`);
    },
    GetSinglePropertyInventory(context, data) {
        return PropertyAPI.get(`Inventory/${data}`);
    },
    GetPropertyInventoryByProperty(context, data) {
        return PropertyAPI.get(`Inventory/Property/${data}`);
    },
    EndPropertyInventory(context, data) {
        return PropertyAPI.put(`Inventory/End/${data.id}`, data);
    },
    DeletePropertyInventory(context, data) {
        return PropertyAPI.delete(`Inventory/${data}`);
    },
    CreatePropertyInventory(context, data) {
        return PropertyAPI.post(`Inventory/Create/${data.campusId}`, data);
    },
    UpdatePropertyInventory(context, data) {
        return PropertyAPI.put(`Inventory/${data.id}`, data);
    },
    UpdatePresentInStation(context, data) {
        return PropertyAPI.post(`Inventory/AccountableOfficer/Present/${data.id}/${data.empId}?present=${data.isPresent}`);
    },
    GetNotFoundInStation(context, data) {
        return PropertyAPI.get(`Inventory/AccountableOfficer/NotFoundInStation/${data}`);
    },
    GetUnserviceableItems(context, data) {
        return PropertyAPI.get(`Inventory/AccountableOfficer/Unserviceable/${data}`);
    },
    GetNotBookedItems(context, data) {
        return PropertyAPI.get(`Inventory/AccountableOfficer/NotBooked/${data}`);
    },

    // Property Inventory Item
    GetPropertyInventoryItem(context, data) {
        return PropertyAPI.get(`InventoryItem/Inventory/${data}`);
    },
    GetPropertyInventoryItemGrouped(context, data) {
        return PropertyAPI.get(`InventoryItem/GroupByAccountableOfficer/${data}`);
    },
    GetPropertyInventoryItemData(context, data) {
        return PropertyAPI.post(`InventoryItem/Multiple`, data);
    },
    DeletePropertyInventoryItem(context, data) {
        return PropertyAPI.delete(`InventoryItem/${data}`);
    },
    CreatePropertyInventoryItem(context, data) {
        return PropertyAPI.post(`InventoryItem/Add`, data);
    },
    UpdateFoundInStation(context, data) {
        return PropertyAPI.put(`InventoryItem/FoundInStation`, data);
    },
    UpdateBookedStatus(context, data) {
        return PropertyAPI.put(`InventoryItem/Update/BookedStatus`, data);
    },

    // Inventory Committee Member
    GetInventoryCommitteeMember(context, data) {
        return PropertyAPI.get(`InventoryCommitteeMember/Inventory/${data}`);
    },
    AddInventoryCommitteeMember(context, data) {
        return PropertyAPI.post(`InventoryCommitteeMember/Add`, data);
    },
    UpdateInventoryCommitteeMember(context, data) {
        return PropertyAPI.put(`InventoryCommitteeMember/${data.id}`, data);
    },
    GetSingleInventoryCommitteeMember(context, data) {
        return PropertyAPI.get(`InventoryCommitteeMember/${data}`);
    },
    DeleteInventoryCommitteeMember(context, data) {
        return PropertyAPI.delete(`InventoryCommitteeMember/Multiple`, { data });
    }
}